<template>
  <div class="paralllax-cookie" style="display: none;" />
</template>
<script>
import cookies from 'js-cookie';

export default {
  props: {
    cookieName: {
      type: String,
      required: true,
    },
    cookieValue: {
      type: String,
      default: '0',
    },
    expires: {
      type: Number,
      default: 1,
    },
  },
  created() {
    const paralllaxAd = document.querySelector('.ad-container--template-inline-content-parallax');
    if (paralllaxAd) {
      cookies.set(this.cookieName, this.cookieValue, { expires: this.expires });
    }
  },
};
</script>
